module.exports = __webpack_public_path__ + "img/box04_03.add5369b.jpg";